import React from "react";

const ContainerWrapper = ({ className = "", children }) => {
  return (
    <div
      className={`${className} flex justify-center items-center h-full z-10 py-8 px-5`}
    >
      {children}
    </div>
  );
};

export default ContainerWrapper;
